// extracted by mini-css-extract-plugin
export default {"btn__wrap":"FeedbackOptions_btn__wrap__+-8mM","btn__options":"FeedbackOptions_btn__options__m7jeV"};